// extracted by mini-css-extract-plugin
export default {"root":"Favorites_root__jDU9V","showMoreWr":"Favorites_showMoreWr__9xu-t"};